import React, { useState, useRef, useCallback, useEffect } from "react";
import PlaylistDetails from "./PlaylistDetails";
import EditPlaylistDetails from "./EditPlaylistDetails";
import "./PlaylistDetails.css";
import { ThemeKey, THEMES } from "../../types/ThemeTypes";

interface PlaylistContainerProps {
    playlistId: string;
}

const PlaylistContainer: React.FC<PlaylistContainerProps> = ({ playlistId }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentTheme, setCurrentTheme] = useState<ThemeKey>("SING");
    const saveFunctionRef = useRef<(() => Promise<boolean>) | null>(null);

    const registerSaveFunction = useCallback((fn: () => Promise<boolean>) => {
        saveFunctionRef.current = fn;
    }, []);

    const handleSaveComplete = () => {
        setIsEditMode(false);
        // Instead of reloading, we'll just update the state
        // The parent component will handle refreshing the data
    };

    const handleCancelEdit = () => {
        setIsEditMode(false);
    };

    const handleEnterEditMode = () => {
        setIsEditMode(true);
    };

    const updateTheme = useCallback((theme: ThemeKey) => {
        setCurrentTheme(theme);
    }, []);

    // Apply theme to the entire App background
    useEffect(() => {
        const appElement = document.querySelector(".App") as HTMLElement;
        if (appElement) {
            const themeColor = THEMES[currentTheme].color;
            const originalBackground = 'linear-gradient(#c8dbf1, 10em, #ffffff)';

            // Set the background to the theme color
            appElement.style.background = themeColor;

            // Clean up when component unmounts
            return () => {
                appElement.style.background = originalBackground;
            };
        }
    }, [currentTheme]);

    return (
        <div className="playlist-container-wrapper">
            {isEditMode ? (
                <EditPlaylistDetails
                    playlistId={playlistId}
                    onSaveComplete={handleSaveComplete}
                    onCancel={handleCancelEdit}
                    registerSaveFunction={registerSaveFunction}
                    onThemeChange={updateTheme}
                />
            ) : (
                <PlaylistDetails
                    playlistId={playlistId}
                    onEdit={handleEnterEditMode}
                    onThemeChange={updateTheme}
                />
            )}
        </div>
    );
};

export default PlaylistContainer; 